export default "__VITE_ASSET__DtM6xykp__"